import React from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { Divider, Typography } from "@material-ui/core";
import { 
    getSingleQuestion, putResponse, updateHeaderInfo, 
    getQuestionResults, addQuestionToDeck, putNextReviewDate, 
    addNote, getUserDetails 
} from "../actions";
import { SingleQuestionCard, CopyrightWidget, LoadingCard, QuestionTestCard } from "../components";
import { deviceData, scrollTop, preventCopy, getThisYear, setContainer, setActiveNavigationWidget } from "../common";
import { isBrowser } from 'react-device-detect';

import "../styles/questionStyles.css";

class SingleQuestionScreen extends React.Component {
    state = {
        answerChoice: -1,
        next: false,
        backgroundColor: "#00567a",
        loading: true, 
        prevID: null,
        nextID: null,
        questionid: null,
        startNext: false,
        refsMats: null,
        yend: getThisYear(),
        ybegin: 2012,
        typetext: 'Single Question',
        type: 'single',
        data: {},
        answered: -1,
        gamemode: 0,
        year: 0,
        spaced: 0,
        deckid: null
    };

    redirectPage = (from = 'undefined') => {
        switch (Number(this.props.question.gameMode)) {
            case 1:
            case 2: {
                return this.props.history.push('/testResultScreen');
            }

            case 3:
            case 4: {
                return this.props.history.push('/myDecks');
            }

            case 5: {
                return this.props.history.goBack();
                // return this.props.history.push('/home');
            }

            case 6: {
                localStorage.setItem('sasp-hideDaily', 1);
                
                return this.props.history.goBack();
            }

            default: {
                localStorage.setItem('sasp-hideDaily', 1);
                return this.props.history.push('/home');
            }
        }
    }

    scrollToTop = () => {
        return scrollTop('QuestionDiv', -64);
    }

    componentDidMount = async () => {
        setActiveNavigationWidget("myDecksFooterIcon");

        preventCopy();
        
        const { mcid, key } = this.props.auth_feedback;
        const { testYear, gameMode, deckID } = this.props.location;
        let questionData;
        let type;

        let _qdata = {
            mcid: mcid,
            key: key,
            questionid: this.props.location.questionid,
            gamemode: this.props.location.gameMode
        }

        await this.props.getUserDetails(mcid, key, deviceData(this.props.location, 'navigate'));
        await this.props.getSingleQuestion(_qdata);

        scrollTop('QuestionDiv', -64);

        document.addEventListener('keydown', this.onKeyDown);

        let _type = 'single';
        let _typetext = 'Review Question';

        if (Number(gameMode) === 6) {
            _type = 'QoD';
            _typetext = 'Question of the Day';
        }

        return this.setState({ 
            ...this.state, 
            backgroundColor: this.getHeaderColor(), 
            gamemode: gameMode,
            year: testYear,
            deckid: deckID,
            questionid: this.props.location.questionid,
            type: type,
            typetext: _typetext
        });
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.question !== this.props.question) {
            if (!Array.isArray(this.props.question) && typeof this.props.question === 'object') {
                if (
                    typeof this.props.question.error !== 'undefined' || 
                    this.props.question.questionID === '' ||
                    (!Number(this.props.question.morequestions) && (this.props.location.gameMode !== 5 && this.props.location.gameMode !== 6))
                ) {
                    return this.redirectPage('componentDidUpdate');
                } else if (this.props.location.gameMode !== 5 && this.props.location.gameMode !== 6) {
                    let prevID = this.props.question.previousQuestionID;
                    let nextID = this.props.question.nextQuestionID;

                    if (
                        typeof prevProps.question.questionID !== 'undefined' 
                        && this.props.location.gameMode > 2
                        && prevState.nextID != this.props.question.questionID
                        && prevState.nextID != null
                    ) {
                        nextID = prevProps.question.questionID;
                    }
                    
                    this.setState({
                        ...this.state,
                        prevID: prevID,
                        nextID: nextID,
                        loading: false, 
                        questionid: this.props.question.questionID,
                    });
                } else {
                    this.setState({
                        ...this.state,
                        loading: false, 
                        questionid: this.props.question.questionID,
                    });
                }
            } else {
                return this.redirectPage('error');
            }   
        }

        if (prevState.answerChoice !== this.state.answerChoice) {
            let putResponseData = {
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                questionID: this.props.question.questionID,
                gamemode: this.props.question.gameMode,
                optionSelected: this.state.answerChoice,
                deckID: this.props.location.deckID,
                tracking: deviceData(this.props.location, 'submit answer')
            };
            await this.props.putResponse(putResponseData);
            
            /*if (prevProps.question.gameMode === 2 || prevProps.question.gameMode === 4) {
                let questionData = {
                    yearvar: this.props.location.testYear,
                    mcid: this.props.auth_feedback.mcid,
                    key: prevProps.auth_feedback.key,
                    gamemode: prevProps.question.gameMode,
                    areavar: ""
                };

                // questionData.tracking = deviceData(this.props.location, 'get single question');
                // await this.props.getQuestion(questionData);
            }*/
        }

        if (prevState.next !== this.state.next) {
            if (Number(prevProps.question.gameMode) === 1 || Number(prevProps.question.gameMode === 2)) {
                let questionData = {
                    yearvar: prevProps.location.testYear,
                    mcid: prevProps.auth_feedback.mcid,
                    key: prevProps.auth_feedback.key,
                    gamemode: prevProps.question.gameMode,
                    areavar: "",
                    deckID: prevProps.location.deckID,
                };

                if (typeof prevProps.question.questionID !== 'undefined') {
                    questionData.previousQuestionID = prevProps.question.questionID;
                }
            }
        
            if (Number(prevProps.question.gameMode) === 3 || Number(prevProps.question.gameMode) === 4) {
                let questionData = {
                    yearvar: "",
                    mcid: prevProps.auth_feedback.mcid,
                    key: prevProps.auth_feedback.key,
                    gamemode: prevProps.location.gameMode,
                    areavar: "",
                    deckID: prevProps.location.deckID
                };

                if (typeof prevProps.question.questionID !== 'undefined') {
                    questionData.previousQuestionID = prevProps.question.questionID;
                }
            }

            this.setState({ ...this.state });
        }
        
        return this.props.updateHeaderInfo({
            route:"/singleQuestionScreen", 
            name: this.setHeaderName(), 
            iconTwo: 'menu', 
            iconOne: 'home',
            color: this.state.backgroundColor
        });
    };

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDown);
    }

    onKeyDown = (event) => {
        const pressedKey = String.fromCharCode(event.keyCode).toLowerCase();

        if (event.ctrlKey && pressedKey === "c") {
            event.returnValue = false;
        }
    }

    getHeaderColor = () => {
        let r;
        switch(Number(this.props.location.testYear)) {
            case 2020: {
                r = '#B2C7E3'; break;
            }
            case 2019: {
                r = '#97A19C'; break;
            }
            case 2018: {
                r = '#7A8D96'; break;
            }
            case 2017: {
                r = '#62B5E5'; break;
            }
            case 2016: {
                r = '#A8AA89'; break;
            }
            case 2015: {
                r = '#A99D8C'; break;
            }
            case 2014: {
                r = '#8ebe74'; break;
            }
            case 2013: {
                r = '#8CA1AD'; break;
                //wrong answers
            }
            case 2012: {
                r = '#A5A5A5'; break;
                //prostate cancer color
            }

            default: {
                r = '#00567a';
                break;
            }
        }

        return r;
    }

    setHeaderName = () => {
        let r = 'temp name';

        switch(this.props.location.gameMode) {
            case 1:
            case 2: {
                r = "SASP " + this.props.location.testYear;
                break;
            }

            case 3:
            case 4: {
                let temp = this.props.deckList.find(item => item.deckID === this.props.location.deckID);
                r = temp.deckname;
                break;
            }

            case 5: {
                r = 'SASP'
            }

            default: {
                r = 'SASP';
                break;
            }
        }
        return r;
    }

    updateOption = answer => {
        return this.setState({
            answerChoice: answer
        });
    };

    openBookNav = (bool) => {
        bool = !this.state.next;
        scrollTop('QuestionDiv', -64);
        return this.setState({
            ...this.state,
            next: bool
        });
    };

    addToDecks = async (id, deckID) => {
        let cnt = 0;
        let obj;
        if (!deckID) {
            for (const i in this.props.deckList) {
                obj = {
                    mcid: this.props.auth_feedback.mcid,
                    key: this.props.auth_feedback.key,
                    questionID: id, 
                    deckID: this.props.deckList[i].deckID
                };

                this.props.addQuestionToDeck(obj);
                cnt++
            }
        } else {
            obj = {
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                questionID: id, 
                deckID: deckID
            };

            this.props.addQuestionToDeck(obj);
        }
        
    }

    skipQuestion = async (questionID) => {
        let data = {
            yearvar: this.props.question.QuestionYear,
            mcid: this.props.auth_feedback.mcid,
            key: this.props.auth_feedback.key,
            gamemode: this.props.location.gameMode,
            areavar: this.props.question.areaVar,
            deckID: (this.props.location.deckID ? this.props.location.deckID : null),
            questionID: questionID
        };

        this.scrollToTop();
        await this.setState({ ...this.state, answerChoice: -1, loading: true });

        // this.props.getQuestion(data);        
    }

    addNote = async (data) => {
        data.questionID = Number(data.questionID);

        data.tracking = this.state.tracking;
        this.props.addNote(data);
    }

    resetTest = () => {
    };

    goBack = () => {
        this.props.history.goBack();
    }

    handleSubmit = async (obj) => {
        if (typeof obj.next !== 'undefined') {
            await this.setState({ ...this.state, loading: true});

            let _goto = {
                mcid: obj.mcid,
                key: obj.key,
                gamemode: this.state.gamemode,
            }

            if (this.state.gamemode < 3) {
                _goto.yearvar = this.state.year;
            }

            if (obj.next > 0) {
                _goto.questionID = obj.next;
            }

            /**
             * questionID: obj.next,
             * yearvar: this.state.year
            */
             scrollTop('QuestionDiv', -64)

            return this.redirectPage()
        } else if (typeof obj.prev !== 'undefined') {
            await this.setState({ ...this.state, loading: true});

            let _goto = {
                mcid: obj.mcid,
                key: obj.key,
                gamemode: this.state.gamemode,
            }

            if (this.state.gamemode < 3) {
                _goto.yearvar = this.state.year;
            }

            if (obj.prev > 0) {
                _goto.questionID = obj.prev;
            }
            scrollTop('QuestionDiv', -64)

            return this.redirectPage()
        } else if (typeof obj.answerid !== 'undefined') {
            const data = {
                mcid: obj.mcid,
                key: obj.key,
                questionID: Number(obj.questionid),
                gamemode: this.state.gamemode,
                optionSelected: obj.choice ? obj.choice : obj.answerid,
                deckID: this.props.location.deckID ? this.props.location.deckID : 0,
                tracking: deviceData(this.props.location, 'submit answer')
            };

            data.tracking.action = 'answer question';

            await this.props.putResponse(data);

            return this.redirectPage();
        }
    }

    render () {
        const { question } = this.props;

        if (!this.state.loading) {        
            return (
                <>
                    <div style={setContainer(isBrowser)} className=" aua-overflow" id="QuestionDiv">
                        <div style={{ padding: "0 0 16px"}}>
                            <div className="flex-row-between">
                                <Typography className="homeDividerText">SASP Question</Typography>
                            </div>
                            
                            <Divider className="SASPTestsDivider" style={{width: "100%", margin: "0"}}/>
                        </div>

                        <div className="question-container" >
                            <QuestionTestCard
                                mykey={this.props.user_details.key}
                                mcid={this.props.user_details.mcid}
                                gamemode={this.state.gamemode}
                                updateOption={this.updateOption}
                                year={this.state.year}
                                spaced={0}
                                submitFunc={this.handleSubmit}
                                answers={this.props.question.qoptions}
                                obj={this.props.question}
                                goNext={this.openBookNav}
                                explanation={this.state.sessionAnsweredQuestion}
                                deckid={ this.state.deckid }
                                prev={this.state.prevID}
                                next={this.state.nextID}
                                cardColor={this.state.backgroundColor}
                                deckList={this.props.deckList}
                                skipQuestion={this.skipQuestion}
                                addToDecks={this.addToDecks}
                                deckText={this.props.question.QuestionYear + " Question " + this.props.question.questionNumber}
                                putNextReviewDate={this.props.putNextReviewDate}
                                addNote={this.addNote}
                                scrollToTop={this.scrollToTop}
                                refsMats={this.state.refsMats}
                                labs={this.props.user_details.labstest}
                                history={this.redirectPage}
                                type={'single'}
                                typetext={this.state.typetext}
                                answered={this.state.answered}
                                id={'QuestionDiv'}
                            />

                            <CopyrightWidget 
                                begin={this.state.ybegin}
                                year={this.state.yend}
                                textAlign={'center'}
                                className="margin-top-48 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                            />
                        </div>
                    </div>
                </>
            ); 
        } else {
            return (
                <LoadingCard text="Loading Question..."/>
            );
        }
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details } = state.auth;
    const { question, sessionAnsweredQuestion } = state.question;
    const { deckList } = state.decks;

    return {
        question,
        user_details,
        sessionAnsweredQuestion,
        auth_feedback,
        deckList
    };
};

export default connect(mapStateToProps, 
    { putResponse, getSingleQuestion, getQuestionResults, addQuestionToDeck, updateHeaderInfo, putNextReviewDate, addNote,getUserDetails }
)( withRouter(SingleQuestionScreen));

//TODO find where question list coming from/how to pull the flow correctly
//into reducers and then into here
//TODO walk through backend flow with pat in more detail on this.
